import { CHECK_LOGIN, LOGIN_USER_SUCCESSFUL, API_ERROR, LOGOUT_USER, LOGOUT_USER_SUCCESS, VERIFY_ADMIN_SUCCESS, VERIFY_ADMIN_FAIL, RESET_STATE } from './actionTypes';

const initialState = {
    loginError: "", message: null, loading: false, verifyAdmin: [],
}
const login = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_LOGIN:
            state = {
                ...state,
                loading: true
            }
            break;
        case LOGIN_USER_SUCCESSFUL:
            state = {
                ...state,
                loading: false
            }
            break;

        case LOGOUT_USER:
            state = { ...state };
            break;

        case LOGOUT_USER_SUCCESS:
            state = { ...state };
            break;

        case API_ERROR:
            state = {
                ...state,
                loading: false,
                loginError: action.payload
            }
            break;
        case VERIFY_ADMIN_SUCCESS:
            state = {
                ...state,
                loading: true,
                verifyAdmin: action.payload,
                permissionArry: action.payload && action.payload.user && action.payload.user.data && action.payload.user.data.permissions
            }
            break;
        case VERIFY_ADMIN_FAIL:
            state = {
                ...state,
                loading: true,
                verifyAdmin: action.payload,
            }
            break;
        case RESET_STATE:
            state = initialState;
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
}

export default login;